<template>
  <ActionButton
    class="shipment-action-button"
    mode="secondary"
    :actions="availableActions"
    :loading="loading"
  />
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { ActionCommand } from '@rygen/rygen-ui/model';
import { Shipment as EsShipment } from '@rygen/tms-search-model/search/shipment';

import { useShipmentBatchAction } from '@/composables';
import { ShipmentAction, ShipmentSearchData } from '@/model';

import ActionButton from '@rygen/rygen-ui/components/button/ActionButton.vue';

const props = defineProps({
  selectedData: {
    type: Array as PropType<ShipmentSearchData[] | EsShipment[]>,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
const { selectedData, loading } = toRefs(props);
const emit = defineEmits<{
  (event: 'command', payload: ActionCommand<ShipmentAction>): void;
}>();

const { availableActions } = useShipmentBatchAction(
  selectedData,
  (command: ActionCommand<ShipmentAction>) => emit('command', command),
);
</script>
